'use strict';

var account = require('./account');

exports.init = function () {
    // load account js for form validation
    account.init();
};
